import type { IHttpApi } from '@cian/http-api';
import type { ILogger } from '@cian/logger/shared';

import {
  fetchFindSearchCatalogItems,
  type TFindSearchCatalogItemsResponse,
} from 'shared/common/repositories/geo/v1/find-search-catalog-items';

export interface IGeoRegionItem {
  id: number;
  displayName: string;
  parentId: number | null;
}

interface IParams {
  httpApi: IHttpApi;
  logger: ILogger;
  text: string;
}

export async function searchRegions({ httpApi, logger, text }: IParams): Promise<IGeoRegionItem[]> {
  try {
    const result = (await fetchFindSearchCatalogItems({
      httpApi,
      parameters: { text },
    })) as TFindSearchCatalogItemsResponse;

    const items = result.response.items ?? [];

    return items.map(item => ({
      id: item.id,
      displayName: item.displayName,
      parentId: item.parentId ?? null,
    }));
  } catch (error) {
    logger.error(error as Error);

    return [];
  }
}
